import React from 'react';
import styled from 'styled-components';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import CalloutStats from './CalloutStats';
import PieChart from './Chart/PieChart';
import { DWB21_Teal } from './colors';
import TwoColumnImageText from './TwoColumnImageText';

const Wrapper = styled.div`
    max-width: 1440px;
`;

export default function Creativity() {
    return (
        <Wrapper>
            <TwoColumnImageText
                variations={['media-first']}
                backgroundColor={DWB21_Teal}
                heading="Creativity with a conscience"
                subHeading="Designers are looking for purpose, not just a paycheck."
                mediaProps={{
                    fallbackImageUrl: publicImageUrl(
                        'design-without-borders/creativity-with-a-conscience.gif'
                    ),
                    mediaAlign: 'center',
                    height: { extraLarge: '90%', large: '100%', normal: '70%', medium: '85%' },
                }}
                borderBottom={true}
                bottom={
                    <CalloutStats
                        side={<PieChart percentage={40} />}
                        stats={'40%'}
                        body={
                            'of freelance creatives have turned down work because of a client’s stance on a social issue they care about'
                        }
                    />
                }
            >
                From healthcare and climate change to racial injustice, 97% of freelancers believe
                creatives have the power to make a real social impact. And with brand activism on
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                the rise, 85% feel it's important to work for clients who share their values. In
                fact, we’re even seeing this play out in designers’ financial decisions.
            </TwoColumnImageText>
        </Wrapper>
    );
}
